import('./entry.client2.jsx');
